import React from "react";
import { ConsultantQualityCheckDataFragment } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { QualityCheckMeta } from "../quality-check-meta";
import { formatLabelDate, hasStatusParams, isPaused } from "../utils";

type Props = {
  data: ConsultantQualityCheckDataFragment;
};

export function HSAIDExtraLabels({ data }: Props) {
  const items: React.ReactNode[] = [];

  const statusData = data.Status;
  const expiresOn = data.ExpiresOn;
  const statusComment = statusData?.Comment;

  if (isPaused(statusData)) {
    items.push(
      <QualityCheckMeta
        title={locale.pausedUntil}
        description={formatLabelDate(statusData.pausedState.pausedUntil)}
      />
    );
  }

  if (expiresOn) {
    items.push(
      <QualityCheckMeta title={locale.Expires} description={formatLabelDate(expiresOn)} />
    );
  }

  if (statusComment) {
    items.push(<QualityCheckMeta title={"HSAID"} description={statusComment} canCopy />);
  }

  if (hasStatusParams(statusData)) {
    const { cardType, cardNumber } = statusData.params;

    if (cardNumber) {
      items.push(
        <QualityCheckMeta title={locale.CardNumber} description={cardNumber} canCopy />
      );
    }

    if (cardType) {
      items.push(
        <QualityCheckMeta
          title={locale.CartType}
          description={locale.cardTypes[cardType]}
        />
      );
    }
  }

  return items;
}
